/**
 * App-wide display date formats (month-before-day, 2-digit day/month, 4-digit year).
 * Use these instead of hardcoding format strings so every screen stays consistent.
 *
 * These are for DISPLAY only — never for API payloads (the backend expects ISO `yyyy-MM-dd`).
 * Tokens are `date-fns` format tokens; the `toLocaleDateString` equivalent is in `TEXT_LOCALE`.
 */
export const DATE_FORMATS = {
  /** Numeric date, e.g. `08/09/2026`. */
  NUMERIC: 'MM/dd/yyyy',
  /** Numeric month/day only, e.g. `08/09`. */
  NUMERIC_SHORT: 'MM/dd',
  /** Numeric date with 2-digit year, e.g. `08/09/26` (legacy progress-tracker display). */
  NUMERIC_YY: 'MM/dd/yy',
  /** Text date, e.g. `Aug 09, 2026` (short month, 2-digit day). */
  TEXT: 'MMM dd, yyyy',
  /** Text date with full month, e.g. `January 09, 2026` (2-digit day). */
  TEXT_LONG: 'MMMM dd, yyyy',
  /** Text date with weekday + full month, e.g. `Monday, January 09, 2026` (note dates). */
  TEXT_WEEKDAY: 'EEEE, MMMM dd, yyyy',
} as const;

/** `toLocaleDateString('en-US', ...)` options matching {@link DATE_FORMATS.TEXT}. */
export const DATE_TEXT_LOCALE_OPTIONS: Intl.DateTimeFormatOptions = {
  month: 'short',
  day: '2-digit',
  year: 'numeric',
};
